/**
 * Which `help` namespace entry (medopd-docs 97) explains the page at each route, for the floating Learn more
 * button. A page that also shows a PageHelpButton beside its title uses the same key.
 */
export const PAGE_HELP_BY_ROUTE: Record<string, string> = {
  '/tokens': 'appointmentsHub',
  '/doctor/bookings': 'myBookings',
  '/doctor/practices': 'myPractices',
  '/doctor/articles': 'myArticles',
  '/doctor/questions': 'doctorQuestions',
  '/doctors/join': 'doctorJoin',
  '/doctor/sign-in': 'doctorSignIn',
  '/labs/join': 'labJoin',
  '/lab/setup': 'labSetup',
  '/lab/tasks': 'labWorklist',
  '/lab/home-collections': 'homeCollectionBoard',
  // Lab and pharmacy screens (medopd-docs 114). Pages under /lab/visits/:id and /lab/accessions/:id/... carry their
  // own PageHelpButton; this map is matched on the exact path, so it can't hold routes with ids.
  '/lab/receiving': 'labReceiving',
  '/lab/qc': 'labQc',
  '/lab/inventory': 'labInventory',
  '/admin/lab-catalog': 'labAdministration',
  '/admin/labs': 'adminLabs',
  '/admin/lab-metrics': 'adminLabMetrics',
  '/pharmacy/medication-inventory': 'pagePharmacyInventory',
  '/admin/in-house-pharmacies': 'adminInHousePharmacy',
  '/admin/pharmacies': 'adminPharmacyRegistry',
  '/admin/pharmacy-approvals': 'adminPharmacyRegistry',
  '/register/pharmacy': 'pharmacyRegistration',
  '/pharmacy/medicine-orders': 'medicineOrdersBoard',
  '/pharmacy/my-deliveries': 'medicineOrdersBoard',
  '/insurance': 'insuranceDesk',
  '/billing/queue': 'billingPayments',
  '/billing/cash-close': 'cashClose',
  '/admin/home-collection': 'homeCollectionSettings',
  '/admin/insurance': 'insuranceSettings',
  '/admin/medicine-ordering': 'medicineOrderingSettings',
  '/admin/payment-gateway': 'paymentGatewaySettings',
  '/admin/engagement/whatsapp': 'clinicWhatsAppSettings',
  '/admin/public-profile': 'clinicPublicListing',
  '/admin/subscription-plans': 'subscriptionPlans',
  '/admin/clinic-account-requests': 'clinicAccountRequests',
  '/admin/clinic-access': 'clinicAccess',
  '/admin/article-review': 'articleReview',
  '/admin/question-moderation': 'questionModeration',
  '/admin/site-visitors': 'siteVisitors',
  '/admin/doctor-verifications': 'doctorVerifications',
  '/admin/lab-verifications': 'labVerifications',
  '/admin/photo-moderation': 'photoModeration',
  '/admin/review-moderation': 'reviewModeration',
  '/admin/test-data': 'testDataStudio',
  '/security/setup-mfa': 'requiredMfaSetup',
  // Pages whose help was the older English-only FEATURE_HELP; moved into the help namespace so it translates.
  '/dashboard': 'pageDashboard',
  '/notifications': 'pageNotifications',
  '/patients/register': 'pagePatientsRegister',
  '/patients': 'pagePatients',
  '/inpatients': 'pageInpatients',
  '/medications': 'pageMedications',
  '/billing': 'pageBilling',
  '/follow-ups': 'pageFollowUps',
  '/doctor/schedule-config': 'pageDoctorScheduleConfig',
  '/doctor/appointments': 'pageDoctorAppointments',
  '/doctor/notes': 'pageDoctorNotes',
  '/doctor/prescriptions': 'pageDoctorPrescriptions',
  '/doctor/templates': 'pageDoctorTemplates',
  '/doctor/revenue': 'pageDoctorRevenue',
  '/doctor/feedback': 'pageDoctorFeedback',
  '/reports': 'pageReports',
  '/pharmacy/inventory': 'pagePharmacyInventory',
  '/admin/hospital-groups': 'pageAdminHospitalGroups',
  '/admin/inventory': 'pageAdminInventory',
  '/admin/staff': 'pageAdminStaff',
  '/admin/fee-schedule': 'pageAdminFeeSchedule',
  '/settings/doctors': 'pageSettingsDoctors',
  '/settings/departments': 'pageSettingsDepartments',
  // Specialty forms + packs (medopd-docs 115). The builder (/settings/forms/:id) shows its own PageHelpButton.
  '/settings/forms': 'formsLibrary',
  '/settings/specialty-packs': 'specialtyPacks',
  '/settings/specialty-features': 'specialtyFeatures',
  '/admin/nav-settings': 'pageAdminNavSettings',
  '/admin/erasure-requests': 'pageAdminErasureRequests',
  '/admin/ai-settings': 'pageAdminAiSettings',
  '/admin/engagement': 'pageAdminEngagement',
  '/admin/checkin-settings': 'pageAdminCheckinSettings',
  '/admin/health-packages': 'pageAdminHealthPackages',
  '/admin/corporate': 'pageAdminCorporate',
  '/admin/revenue-intelligence': 'pageAdminRevenueIntelligence',
  '/admin/feedback-nps': 'pageAdminFeedbackNps',
  '/admin/quality-measures': 'pageAdminQualityMeasures',
  '/admin/follow-ups': 'pageAdminFollowUps',
  '/admin/referrals': 'pageAdminReferrals',
  '/growth': 'pageGrowth',
  '/growth/campaigns': 'pageGrowthCampaigns',
  '/profile': 'pageProfile',
};
